'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useNavSubItemGroup_unstable", {
    enumerable: true,
    get: function() {
        return useNavSubItemGroup_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactutilities = require("@fluentui/react-utilities");
const _reactmotion = require("@fluentui/react-motion");
const _reactmotioncomponentspreview = require("@fluentui/react-motion-components-preview");
const _NavCategoryContext = require("../NavCategoryContext");
const useNavSubItemGroup_unstable = (props, ref)=>{
    const { open } = (0, _NavCategoryContext.useNavCategoryContext_unstable)();
    return {
        open,
        components: {
            root: 'div',
            collapseMotion: _reactmotioncomponentspreview.Collapse
        },
        root: _reactutilities.slot.always((0, _reactutilities.getIntrinsicElementProps)('div', {
            ...props,
            ref
        }), {
            elementType: 'div'
        }),
        collapseMotion: (0, _reactmotion.presenceMotionSlot)(props.collapseMotion, {
            elementType: _reactmotioncomponentspreview.Collapse,
            defaultProps: {
                visible: open,
                unmountOnExit: true
            }
        })
    };
};
